export type ThemeId = "ocean" | "forest" | "berry" | "midnight";

export interface ThemeOption {
  id: ThemeId;
  label: string;
  description: string;
  preview: [string, string, string];
}

export const THEME_OPTIONS: ThemeOption[] = [
  {
    id: "ocean",
    label: "Ocean",
    description: "Blue with coral",
    preview: ["#1d4ed8", "#142f8f", "#ff7a3d"],
  },
  {
    id: "forest",
    label: "Forest",
    description: "Green with amber",
    preview: ["#0f766e", "#115e59", "#f59e0b"],
  },
  {
    id: "berry",
    label: "Berry",
    description: "Purple with rose",
    preview: ["#7c3aed", "#5b21b6", "#ec4899"],
  },
  {
    id: "midnight",
    label: "Midnight",
    description: "Navy with cyan",
    preview: ["#172554", "#0f172a", "#22d3ee"],
  },
];

const STORAGE_KEY = "smp_theme_v1";
const DEFAULT_THEME: ThemeId = "ocean";

export function isThemeId(value: unknown): value is ThemeId {
  return THEME_OPTIONS.some((theme) => theme.id === value);
}

export function getSavedTheme(): ThemeId {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return isThemeId(saved) ? saved : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme: ThemeId, persist = true): void {
  document.documentElement.dataset.theme = theme;
  if (!persist) return;
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Storage can be unavailable in private mode; the active page can still
    // use the chosen theme for the rest of this visit.
  }
}

export function initialiseTheme(): void {
  applyTheme(getSavedTheme(), false);
}
